<template>
  <div class="blog-item-container flex-between" @click="toBlogDetail">
    <div  class="flex-between action-text" v-show="action">
      <span>你点赞了此攻略</span>
      <span> {{data.operation_at | articleTimeFormatFilter}}</span>
    </div>
    <div class="blog-item-info">
      <h1 class="blog-title" v-html="highLight(data.title||data.name)"></h1>
      <div class="flex-between">
        <span class="blog-time" v-if="data.publish_at">{{ data.publish_at | timeFilter('YYYY-MM-DD') }}</span>
        <div class="blog-view flex-start">
          <span class="iconfont iconeye" v-if="itemType === 'list'"/>
          <span class="view-text" v-else-if="itemType === 'detail'">阅读</span>
          <span>{{ data.view_count || data.views_count }}</span>
        </div>
      </div>
    </div>
    <div class="blog-logo">
      <img :src="data.images[0]" alt="" v-if="search">
      <img :src="data.img" alt="" v-else>
    </div>
  </div>
</template>

<script>
	import { envMixin } from '../../../assets/js/mixin/global'

	export default {
		name: 'blog-item',
		mixins: [ envMixin ],
		props: {
			data: {
				type: Object,
				default: () => {
					return {}
				}
			},
			itemType: {
				type: String,
				default: 'list'
			},
			search: {
				type: Boolean,
				default: false
			},
			searchText: {
				type: String,
				default: ''
			},
      action:{
			  type:Boolean,
        default:false
      }
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {
			// 高亮过滤
      highLight (content) {
				if (this.search) {
					let reg = `/${ this.searchText }/g`
					return content.replace(eval(reg), `<span class="con_height_light" style="color: #ff6644">${ this.searchText }</span>`)
				} else {
					return content
				}
			},
			toBlogDetail () {
				let { token } = this.$route.params
				let { title, img } = this.data
				this.$db.ls.set('shareNeed', true)
				if (token !== this.data.token) {
					if (this.isWxMini) {
						this.$wechat.miniProgram.navigateTo({
							url: `/pages/blog-detail/blog-detail?url=${ process.env.VUE_APP_HOST }/community/blog/${ this.data.token }&title=${ title }&image=${ img }`
						})
					} else {
						this.$router.push(`/community/blog/${ this.data.token }`)
					}
				} else {
					window.scrollTo(0, 0)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";
  .blog-item-container {
    flex-wrap:wrap;
    padding: 16px 24px;
    background-color: $color-light;
    .action-text{
      min-width:100%;
      color: #9c9c9c !important;
      font-size: $font-size-small;
      margin-bottom:10px;
    }
    .blog-item-info {
      flex: 1;
      margin-right: 24px;
      .blog-title {
        font-size: $font-size-medium-x;
        color: $color-title;
        line-height: 24px;
        margin-bottom: 6px;
      }
      .blog-time, .blog-view {
        color: #9c9c9c;
        font-size: $font-size-small;
      }
      .blog-view {
        .iconfont {
          margin-right: 4px;
        }
        .view-text {
          margin-right: 4px;
        }
      }
    }
    .blog-logo {
      width: 70px;
      height: 70px;
      img {
        width: 70px;
        height: 70px;
        border-radius: 4px;
        object-fit: cover;
      }
    }
  }
</style>
